"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const logging_1 = require("@prosay/logging");
const deepEffect_1 = require("./deepEffect");
const logger = logging_1.getLogger(__filename);
exports.useAsyncEffect = (f, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
deps, name) => deepEffect_1.useDeepCompareEffect(() => {
    if (name) {
        logger.debug `useAsyncEffect processed for ${name}`;
    }
    let cleanup;
    const result = f();
    if (typeof result === "function") {
        cleanup = result;
    }
    else if (Promise.resolve(result) === result) {
        result.then(cleanupFunction => {
            if (typeof cleanupFunction === "function") {
                cleanup = cleanupFunction;
            }
        });
    }
    return () => {
        if (name) {
            logger.debug `useAsyncEffect cleanup processed for ${name}.`;
        }
        if (cleanup) {
            cleanup();
        }
    };
}, deps);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZWZmZWN0QXN5bmMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaG9va3MvZWZmZWN0QXN5bmMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw2Q0FBeUM7QUFDekMsNkNBQWlEO0FBRWpELE1BQU0sTUFBTSxHQUFHLG1CQUFTLENBQUMsVUFBVSxDQUFDLENBQUE7QUFJdkIsUUFBQSxjQUFjLEdBQUcsQ0FDMUIsQ0FBMkU7QUFDM0UsOERBQThEO0FBQzlELElBQXFCLEVBQ3JCLElBQWEsRUFDZixFQUFFLENBQ0EsaUNBQW9CLENBQUMsR0FBRyxFQUFFO0lBQ3RCLElBQUksSUFBSSxFQUFFO1FBQ04sTUFBTSxDQUFDLEtBQUssQ0FBQSxnQ0FBZ0MsSUFBSSxFQUFFLENBQUE7S0FDckQ7SUFFRCxJQUFJLE9BQXlDLENBQUE7SUFDN0MsTUFBTSxNQUFNLEdBQUcsQ0FBQyxFQUFFLENBQUE7SUFDbEIsSUFBSSxPQUFPLE1BQU0sS0FBSyxVQUFVLEVBQUU7UUFDOUIsT0FBTyxHQUFHLE1BQU0sQ0FBQTtLQUNuQjtTQUFNLElBQUksT0FBTyxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsS0FBSyxNQUFNLEVBQUU7UUFDM0MsTUFBTSxDQUFDLElBQUksQ0FBQyxlQUFlLENBQUMsRUFBRTtZQUMxQixJQUFJLE9BQU8sZUFBZSxLQUFLLFVBQVUsRUFBRTtnQkFDdkMsT0FBTyxHQUFHLGVBQWUsQ0FBQTthQUM1QjtRQUNMLENBQUMsQ0FBQyxDQUFBO0tBQ0w7SUFDRCxPQUFPLEdBQUcsRUFBRTtRQUNSLElBQUksSUFBSSxFQUFFO1lBQ04sTUFBTSxDQUFDLEtBQUssQ0FBQSx3Q0FBd0MsSUFBSSxHQUFHLENBQUE7U0FDOUQ7UUFFRCxJQUFJLE9BQU8sRUFBRTtZQUNULE9BQU8sRUFBRSxDQUFBO1NBQ1o7SUFDTCxDQUFDLENBQUE7QUFDTCxDQUFDLEVBQUUsSUFBSSxDQUFDLENBQUEifQ==